import { api } from '@creditsights/api-ui-web';

export const fetchRetailPDF = async (
  companyId: string,
  printedFor?: string,
  entitlements?: Array<Array<Array<string>>>
): Promise<any> => {
  return api.get(`content/v1/pdf/retail/company%2F${companyId}`, {
    params: {
      printedFor,
      entitlements: JSON.stringify(entitlements),
    },
    responseType: 'blob',
  });
};
